import { Grid } from "@mui/material"
// import Dropdown from "components/Dropdown"
import Header from "components/Header/Header"
import AppButton from "components/StyledComponents/AppButton"
import { createBreadcrumbs } from "helpers/breadCrumbs"
import React, { Fragment, useEffect, useState } from "react"
import { Col, Container, Row } from "react-bootstrap"
// import { useHistory } from "react-router-dom"
import ExpandableTable from "components/ExpandableTable"
import { useDispatch, useSelector } from "react-redux"
import { exportNationalLeaderboardDataAction, getNationalLeaderboardAction } from "redux/GM/actions"
import { appActions } from "redux/app/slice/app"
import { expandedNationalLeaderboardColumns, NationalLeaderboardColumns } from "helpers/constant"

const NationalLeaderboard = () => {
  const [breadCrumbs, setBreadcrumbs] = useState([])
  const [currentPage, setCurrentPage] = useState(1)
  const dispatch = useDispatch()
  const { nationalLeaderboardData } = useSelector((state) => state?.gm)
  const { date, employeeClass, orderBy } = useSelector((state) => state?.app?.filters || "")
  // const history = useHistory()

  // const handleOtherLeaderboardRoute = (e) => {
  //   const path =
  //     e === "leaderboard"
  //       ? "/marketing/dashboard/leaderboard"
  //       : `/marketing/dashboard/leaderboard/${e}-leaderboard`
  //   history.push(path)
  // }

  useEffect(() => {
    const role = employeeClass ? employeeClass : "All"
    const sort = orderBy ? orderBy : "total_coins"
    dispatch(getNationalLeaderboardAction({ page: currentPage, date, role, sort }))
  }, [currentPage, date, employeeClass, orderBy])

  useEffect(() => {
    setCurrentPage(1)
  }, [date, employeeClass, orderBy])

  useEffect(() => {
    setBreadcrumbs(createBreadcrumbs())
    document.title = "National Leaderboard"
    setCurrentPage(1)
    dispatch(appActions.initFilters())
  }, [])

  return (
    <Fragment>
      <Container fluid className="p-0">
        <Row>
          <Col lg="12">
            <Header title="National Leaderboard" breadCrumbs={breadCrumbs}>
              <Grid container item gap={2}>
                <AppButton
                  sx={{ padding: "13px 36px" }}
                  onClick={() => dispatch(exportNationalLeaderboardDataAction({ date }))}>
                  Export to Excel
                </AppButton>
                {/* <Dropdown
                  menuItems={LeaderboardOptions}
                  onChange={(e) => handleOtherLeaderboardRoute(e)}>
                  <Box role="button">
                    <AppButton sx={{ padding: "13px 36px" }}>Other Leaderboard</AppButton>
                  </Box>
                </Dropdown> */}
              </Grid>
            </Header>
          </Col>
        </Row>
        <Row>
          <Col lg="12">
            <ExpandableTable
              setPage={setCurrentPage}
              currentPage={currentPage}
              totalPage={nationalLeaderboardData?.pages}
              rowsData={nationalLeaderboardData?.results}
              columns={NationalLeaderboardColumns}
              expandMapping={expandedNationalLeaderboardColumns}
            />
          </Col>
        </Row>
      </Container>
    </Fragment>
  )
}

export default NationalLeaderboard

// const LeaderboardOptions = [
//   { label: "Frontline Performance", value: "leaderboard" },
//   { label: "Quiz Leaderboard", value: "quiz" },
//   { label: "Gamification Leaderboard", value: "gamification" },
//   { label: "Group Leaderboard", value: "group" }
// ]
